export default __webpack_public_path__ + "static/media/IMG_4575-min.d282ce74.JPG";